import React from 'react';
import { motion } from 'framer-motion';
const objections = [{
  question: '¿Es esto para mí si no sé absolutamente nada de IA?',
  answer: 'Exactamente para ti. Empieza desde cero absoluto. No se asume ningún conocimiento previo.'
}, {
  question: '¿Necesito instalar algo o tener una computadora especial?',
  answer: 'Solo necesitas leer el PDF. En tu teléfono, tablet o computadora. Lo tienes en tus manos en 2 minutos.'
}, {
  question: '¿Y si lo leo y siento que no me sirvió?',
  answer: 'Con la primera historia ya entiendes más de IA que la mayoría de personas a tu alrededor. Eso está garantizado por la experiencia de quienes ya se sentaron en esa mesa.'
}];
export function ObjectionsSection() {
  return <section className="w-full bg-navy pt-14 md:pt-[88px] pb-6 md:pb-10 px-6" data-id="element-195">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[680px] mx-auto flex flex-col items-center" data-id="element-196">
        <h2 className="text-[28px] md:text-[36px] font-serif font-bold text-white leading-[1.3] text-center" data-id="element-197">
          Lo que probablemente
          <br data-id="element-198" />
          estás pensando ahora mismo
        </h2>

        <div className="w-full space-y-5 mt-8" data-id="element-199">
          {objections.map((item, index) => <div key={index} className="w-full" data-id="element-200">
              <p className="text-[17px] font-sans italic text-gold leading-[1.6]" data-id="element-201">
                "{item.question}"
              </p>
              <p className="text-[16px] font-sans text-white leading-[1.85] mt-2" data-id="element-202">
                {item.answer}
              </p>
            </div>)}
        </div>
      </motion.div>
    </section>;
}